import script from "./WidgetProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetProfile.vue?vue&type=script&setup=true&lang=ts"

import "./WidgetProfile.vue?vue&type=style&index=0&id=ac9f0aa0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac9f0aa0"]])

export default __exports__